import ApplicationController from '../application_controller'
import consumer from 'channels/consumer'

class SyncMessagesController extends ApplicationController {
  static values = {
    'uuid': String
  }

  static targets = ['syncButton']

  connect() {
    const controller = this

    if (this.hasSyncButtonTarget) {
      this.syncButtonTarget.addEventListener('click', (e) => {
        e.target.classList.add('loading', 'disabled')
      })
    }

    this.subscription = consumer.subscriptions.create(
      { channel: 'Events::NewEventChannel', uuid: this.uuidValue },
      {
        received(data) {
          if(data.done) {
            controller.syncButtonTarget.classList.remove('loading', 'disabled')
          } else if (data.url) {
            this.prependFromUrl(data)
          } else {
            this.prependEvent(data)
          }
        },
        prependFromUrl(data) {
          this.queue = (this.queue || Promise.resolve())
            .then(() => fetch(data.url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } }))
            .then((response) => response.ok ? response.text() : Promise.reject(new Error(`Event request failed: ${response.status}`)))
            .then((html) => this.prependEvent({ ...data, html }))
            .catch((error) => console.error(error))
        },
        prependEvent(data) {
          const eventList = document.getElementById(`${data.type}-timeline`) || document.getElementById('history-timeline')
          let html = document.createElement('template')
          html.innerHTML = data.html.trim()
          let elem = html.content.querySelector('.event-item')
          if (!eventList || !elem || (elem.id && document.getElementById(elem.id))) return

          elem.classList.add('fadeInDown')
          eventList.prepend(html.content)
        }
      }
    )
  }

  disconnect() {
    this.subscription.unsubscribe();
  }
}

export default SyncMessagesController
